export enum LeadDraftInfoStatusType {
  DRAFT = '777bdf0b-046a-4bc1-ac05-c75ac83600a5',
  REJECTED_BY_SALES = '96fde90a-29ae-49c6-b3b6-1e0a1a274ffc',
  ASSIGNED = '4776629b-e215-432f-815a-106b01bd5081',
  TM_ASSIGNED = 'd5b37328-0614-4bfc-8eb7-9dda71be9439',
  NO_POTENTIAL = 'e7063f06-2d71-4a08-9d42-fd3722f87f7f',
  FUTURE_LEAD = 'f2235291-b5af-4685-9608-45557ac27109'
}
